import Charge from "@/views/charge/Charge"
import {waitcharge} from './waitcharge'
import {havecharge} from './havecharge'
import {haverefund} from './haverefund'
export const charge = {
  path: '/charge',
  name: 'Charge',
  component: Charge,
  children:[
    waitcharge,havecharge,haverefund
  ]
}


// WEBPACK FOOTER //
// ./src/router/index/charge/index.js